import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (param) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'SEALING_INSPECTION_VALUE_Put',
    method: 'PUT',
  });
  useEffect(() => {
    if (param) {
      exec({ url: `/api/sealing/inspection/sample/${param.id}`, data: param });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);
  return [isRequestSuccessed, exec];
});
